import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./darktheme.css";
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { MessageAuthProvider } from './context/MessageAuthProvider';
import ApolloClientProvider from './context/ApolloClient';
import { CacheProvider } from '@emotion/react';
import muiCache from './emotionCache';
import Clarity from './clarity/clarity';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CacheProvider value={muiCache}>
      <ApolloClientProvider>
        <AuthProvider>
          <MessageAuthProvider>
            <Clarity />
            <App />
          </MessageAuthProvider>
        </AuthProvider>
      </ApolloClientProvider>
    </CacheProvider>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
